import { KeyboardEvent } from "react";
import { keycloakUtils } from "itsf-ui-common";
import { useHistory } from "react-router-dom";
import { ROUTES } from "@constants";
import { useLoginLogout } from "@hooks/useLoginLogout";

interface IUseHeaderProps {
    logoutCallback?(): void;
}

export const useHeader = (props?: IUseHeaderProps) => {
    const { logoutCallback } = props ?? {};
    const { push } = useHistory();
    const { logIn, logOut } = useLoginLogout();

    const handleCartClick = () => {
        push(`${ROUTES.CART_PAGE_URL}`);
    };

    const handleLoginLogout = () => {
        if (keycloakUtils.isAuthenticated()) {
            logOut("", logoutCallback);
        } else {
            logIn();
        }
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter") {
            handleLoginLogout();
        }
    };

    return {
        handleCartClick,
        handleKeyDown,
        handleLoginLogout,
    };
};
